// lib/web/favicon.ts
// Favicon URL helpers for the agent web-browsing UX (ChatGPT/Claude-style source pills).
//
// Primary source is Google's S2 favicon service — returns a PNG that renders in a
// plain <img>, works for virtually every domain, and accepts a size hint. DuckDuckGo
// is the fallback. The <Favicon> component chains these with onError before falling
// back to a neutral globe glyph, so a broken icon never blocks the UX.

/** Extract a clean, display-ready hostname (no protocol, no leading www.). */
export function domainFromUrl(input: string): string {
  if (!input) return '';
  try {
    const u = new URL(/^https?:\/\//i.test(input) ? input : `https://${input}`);
    return u.hostname.replace(/^www\./i, '');
  } catch {
    return input
      .replace(/^https?:\/\//i, '')
      .replace(/^www\./i, '')
      .split(/[/?#]/)[0] ?? '';
  }
}

/** Google S2 favicon service (PNG). Best default — broad coverage + size hint. */
export function googleFaviconUrl(domain: string, size = 64): string {
  return `https://www.google.com/s2/favicons?domain=${encodeURIComponent(domain)}&sz=${size}`;
}

/** DuckDuckGo favicon service (.ico). Used as a fallback when S2 misses. */
export function duckDuckGoFaviconUrl(domain: string): string {
  return `https://icons.duckduckgo.com/ip3/${encodeURIComponent(domain)}.ico`;
}
